import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgStepDone = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    ref={svgRef}
    {...props}
  >
    <circle cx={16} cy={16} r={14.5} stroke="#084" strokeWidth={3} />
    <path
      fill="#084"
      d="M20.508 11.903a1.5 1.5 0 012.154 2.083l-.107.11-7.452 6.956-4.595-4.289a1.5 1.5 0 011.93-2.292l.117.1 2.547 2.377 5.406-5.045z"
    />
  </svg>
));
SvgStepDone.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStepDone;
